import styled, { css, DefaultTheme } from 'styled-components';
import { InputSearchWithSidebarContainer } from '../input-search-with-sidebar/input-search-with-sidebar.styles';
import { InputSelect } from '../input-select-with-sidebar/input-select-with-sidebar.styles';
import { SidebarBody } from '../sidebar-right/sidebar.styles';
import { TextInput } from '../typography/typography.styles';
import { Appearence } from './types';

const getAppearence = (appearence: Appearence, theme: DefaultTheme) =>
  ({
    yellow: {
      iconColor: theme.colors.baseColors.yellow150,
      borderColor: theme.colors.baseColors.yellow100,
      backgroundColor: theme.colors.baseColors.yellow5,
      arrowHoverColor: theme.colors.baseColors.yellow100,
    },
    blue: {
      iconColor: theme.colors.baseColors.blue100,
      borderColor: theme.colors.baseColors.blue100,
      backgroundColor: theme.colors.baseColors.blue5,
      arrowHoverColor: theme.colors.baseColors.blue100,
    },
    transparent: {
      iconColor: theme.colors.baseColors.red100,
      borderColor: theme.colors.namedColors.transparent,
      backgroundColor: theme.colors.namedColors.transparent,
      arrowHoverColor: theme.colors.baseColors.grey150,
    },
  })[appearence];

export const IconWrapper = styled.div`
  width: 20px;
  height: 20px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const Select = styled(InputSelect)`
  border-radius: 10px;
  display: flex;
  gap: 0.8rem;
  align-items: center;
  padding: 1rem 1.6rem !important;
`;

export const ArrowContainer = styled.div`
  display: flex;
  margin-left: auto;
  svg path {
    fill: #2c363f;
    transition: fill 0.2s;
  }
`;

export const SidebarContainer = styled(InputSearchWithSidebarContainer)<{
  $appearence: Appearence;
  $bodyBackground?: string;
  $width?: string;
}>`
  ${SidebarBody} {
    background-color: ${({ $bodyBackground = '#f4f7fc' }) => $bodyBackground};
  }

  ${({ $appearence, $width, theme }) => {
    const { iconColor, backgroundColor, borderColor, arrowHoverColor } =
      getAppearence($appearence, theme);

    return css`
      ${Select} {
        border: 1px solid ${borderColor};
        background-color: ${backgroundColor};
        &:hover ${ArrowContainer} svg path {
          fill: ${arrowHoverColor};
        }
      }

      ${IconWrapper} {
        color: ${iconColor};
      }
      width: ${$width ?? '100%'};
    `;
  }}
`;

export const InputPlaceholderDark = styled.span`
  ${TextInput};
`;
